<p class="font-bold" i18n>Please enter the PLMN information specified as below.</p>

<rs-guidance-box class="mb-3" i18n>
  Guidance: The PLMN information is comprised of MCC+MNC and each PLMN entry (indicative of PNN Record ID) is referenced to one network name
  or more in EF_PNN (PLMN Network Name). For example, the first record of EF_OPL or EF_OPL5G contains 311 (MCC) 123 (MNC) and its PNN Record
  ID is 1, which is tied to the first record of EF_PNN specifying "RiPSIM Wireless" as an example.
</rs-guidance-box>

<div class="mx-6">
  <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />
  <div style="width: 750px">
    <p-table
      showGridlines="true"
      stripedRows="true"
      [value]="profileValues.plmnInformation"
      [resizableColumns]="true"
      styleClass="p-datatable-striped p-datatable-gridlines"
    >
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 7rem" />
          <col />
          <col />
          <col />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th i18n>Record #</th>
          <th>
            <div i18n>Mobile Country Code</div>
            <div class="font-medium" i18n>(3-digit number)</div>
          </th>
          <th>
            <div i18n>Mobile Network Code</div>
            <div i18n>(2 or 3-digit number)</div>
          </th>
          <th>
            <div i18n>PNN Record ID</div>
            <div i18n>(1 to 10)</div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-plmnInformation>
        <tr>
          <td style="text-align: center">{{ plmnInformation.recordNumber }}</td>
          <td>
            <input
              pInputText
              rsNumberWildCardInput
              class="maximize-inputs console-text"
              [maxlength]="3"
              [(ngModel)]="plmnInformation.mobileCountryCode"
              (input)="handleFormEvents()"
            />
          </td>
          <td>
            <input
              pInputText
              rsNumberWildCardInput
              class="maximize-inputs console-text"
              [maxlength]="3"
              [(ngModel)]="plmnInformation.mobileNetworkCode"
              (input)="handleFormEvents()"
            />
          </td>
          <td>
            <p-inputNumber
              class="maximize-inputs"
              inputStyleClass="maximize-inputs console-text"
              [(ngModel)]="plmnInformation.pnnRecordId"
              [maxlength]="2"
              [useGrouping]="false"
              (onBlur)="handleFormEvents()"
            ></p-inputNumber>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
